import { Menu } from "@mui/material";
import styled from "styled-components";
import { theme } from "../../../../Customization/Theme";

export const AllChatPannelWrapper = styled.div`
  background-color: #fff;
  z-index: 1;
  flex-grow: 1;
  overflow-x: hidden;
  min-width: 364px;
  max-width: 364px;

  @media screen and (max-width: 1400px) {
  min-width: 320px;
  max-width: 320px;
}
  margin: 0;
  position: relative;
  .chat-action-bar {
    border: 1px solid;
    width: 100%;
    .wrapper-action {
      display: flex;
    }
  }
  .chat-window-content {
    margin-top: 4px;
    /* padding-top: 8px; */
    padding-left: 4px;
    /* margin-right: 4px; */
    /* height: 100%; */
    overflow: hidden;
    overflow-x: hidden;
    height: calc(100vh - 180px);
  }
  .chat-window-content:hover {
    overflow: auto;
    overflow-x: hidden;
  }
  .chat-window-content::-webkit-scrollbar {
    width: 7px;
  }

  .chat-window-content::-webkit-scrollbar-track {
    /* margin-bottom: 9rem; */
  }

  .chat-window-content::-webkit-scrollbar-thumb {
    background-color: rgba(126, 131, 146, 0.5);
    border-radius: 4px;
  }
`;

export const TopBar = styled.div`
  width: 100%;
  background-color: ${theme.palette.default.white};
  display: flex;
  align-items: center;
  padding: 0.675rem 0.675rem 0.675rem 0.675rem;
  .icon {
    width: 14%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .search {
    width: 100%;
    input {
      background-color: rgb(245, 246, 248);
      border: 1px solid rgb(203, 205, 211);
    }
  }
`;

export const TabFilter = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0rem 0.675rem 0rem 0.675rem;
  height: 48px;
  box-shadow: 0px 2px 4px rgb(0 0 0 / 10%);

  .MuiBox-root {
    border-bottom: none;
  }

  .filter {
    width: 28px;
    height: 28px;
    & .MuiSvgIcon-root {
      color: ${theme.palette.default.darkGrey};
      font-size: 1.4rem;
    }
  }
`;

export const AllChatFilterMenu = styled(Menu)`
  & .MuiPaper-root {
    color: ${theme.palette.default.darkGrey};
    font-size: 12px;
  }
  & .MuiMenuItem-root {
    display: flex;
    justify-content: space-between;
  }
`;
export const StyleTabHeaderWrapper = styled.div`
  && {
    width: 100%;
    .countBox {
      margin-left: 0.5rem;
      background-color: ${theme.palette.default.lightGrey};
      border-radius: 20%;
      padding: 0.2rem 0.5rem;

      font-size: 0.85rem;
    }
  }
`;

export const StyledCircularLoaderBox = styled.div`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 1rem;
    margin: 1rem;
    .MuiCircularProgress-root {
      height: 32px;
      width: 32px;
    }

    p {
      font-size: 14px;
      color: ${theme.palette.default.darkGrey};
    }
  }
`;
